import { Badge, Button, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import IconButton from '@components/IconButton';

import { useHealthChart } from '@hooks/useHealthChart';

import Dialog from './Dialog';

const messages = defineMessages({
  filter: {
    id: 'filterButton.moreFilters',
    defaultMessage: 'More Filters',
  },
  clearFilters: {
    id: 'filterModalContent.clearFilters',
    defaultMessage: 'Clear Filters',
  },
  filterBy: {
    id: 'filterModalContent.filterBy',
    defaultMessage: 'Filter By',
  },
  reset: {
    id: 'GLOBAL.reset',
    defaultMessage: 'Reset',
  },
});

export default function ContentFilterButton() {
  const [numFilters, setNumFilters] = useState<number>(0);
  const [open, setOpen] = React.useState<boolean>(false);
  const { formatMessage } = useIntl();
  const { clinicalStatus, setSourceAndClinicalFilters, sources } =
    useHealthChart();

  useEffect(() => {
    const sourceFilters = sources?.length ? 1 : 0;
    const clinicalStatusFilter = typeof clinicalStatus === 'boolean' ? 1 : 0;
    setNumFilters(sourceFilters + clinicalStatusFilter);
  }, [clinicalStatus, sources?.length]);

  const handleCloseDialog = () => {
    setOpen(false);
  };
  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleFilterReset = () => {
    setSourceAndClinicalFilters({
      sources: undefined,
      clinicalStatus: undefined,
    });
  };

  return (
    <Stack direction="row">
      <Badge
        badgeContent={numFilters}
        color="secondary"
        sx={{ float: 'right' }}
      >
        <IconButton
          iconType="fal"
          name="sliders"
          onClick={handleOpenDialog}
          size={18}
        />
      </Badge>

      {numFilters > 0 && (
        <Button onClick={handleFilterReset} size="small" variant="text">
          {formatMessage(messages.reset)}
        </Button>
      )}

      <Dialog onClose={handleCloseDialog} open={open} />
    </Stack>
  );
}
